// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__AlOof","topBottomGutter":"Layout_topBottomGutter__gFRuB"};